import { Component, ElementRef, inject, Input, IterableDiffer, IterableDiffers, QueryList, ViewChildren } from '@angular/core';
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendForm } from '../../netgen/FrontendForm';
import { SmFormFieldComponent } from '../sm-form-field/sm-form-field.component';

@Component({
    selector: 'sm-form',
    templateUrl: './sm-form.component.html',
    styleUrls: ['./sm-form.component.scss'],
    standalone: false
})
export class SmFormComponent {
    elementRef = inject(ElementRef);
    differs = inject(IterableDiffers);

    _form: FrontendForm = null;
    _fields: FrontendField[][] = [];
    private fieldsDiffer: IterableDiffer<any>;
  
    @Input()
    fixedWidth: number = null;

    @Input()
    fixedHeight: number = null;

    @Input()
    fullHeight = false;
    
    @ViewChildren('fields') fields: QueryList<SmFormFieldComponent>;

    @Input()
    set form(value: FrontendForm | null) {
        this._form = value;
        this._fields = value ? value.getGroupedFields() : [];
        this.fieldsDiffer = value?.fields ? this.differs.find(value.fields).create<any>() : null;
    }

    ngDoCheck(): void {
        if (!this._form?.fields || !this.fieldsDiffer) {
            return;
        }

        if (this.fieldsDiffer.diff(this._form.fields)) {
            this._fields = this._form.getGroupedFields();
        }
    }

    focus(fieldId?: string): void {
        if (Utils.isNoe(fieldId)) {
            if (this.fields.length > 0) {
                this.fields.first.focus();
            }
        }
        else {
            const nativeElement = this.elementRef.nativeElement as HTMLElement;
            const fieldElement = nativeElement.querySelector(`[data-id="${fieldId}"]`);
            (fieldElement as any)?.focus();
        }
    }
    
    thisComponentAsTableEditorInited(): void {
        if (this.fields.length > 0) {
            this.fields.first.thisComponentAsTableEditorInited();
        }
    }

}
